export const analysisKeys = {
  all: ['analysis'] as const,
  profiles: () => [...analysisKeys.all, 'profile'] as const,
  profile: (profileId: string) => [...analysisKeys.profiles(), profileId] as const,
  readinessAll: () => [...analysisKeys.all, 'readiness'] as const,
  readiness: (profileId: string, versionId: string) =>
    [...analysisKeys.readinessAll(), profileId, versionId] as const,
  resultsAll: () => [...analysisKeys.all, 'results'] as const,
  results: (profileId: string) => [...analysisKeys.resultsAll(), profileId] as const,
  datasetResultsAll: () => [...analysisKeys.all, 'dataset-results'] as const,
  datasetResults: (datasetProfileId: string, searchParams: string) =>
    [...analysisKeys.datasetResultsAll(), datasetProfileId, searchParams] as const,
  versions: () => [...analysisKeys.all, 'version'] as const,
  version: (versionId: string) => [...analysisKeys.versions(), versionId] as const,
};
